<template>
  <div id="OrgTeamDetailDialog">
    <el-dialog class="eb-dialog_gray" @open="openHandler" :visible.sync="dialogVisible" width="552px">
      <div style="padding:0;">
        <div class="company-title">
          <span class="company-title-span"></span>
          <img id="userInfo_departLogo" class="departLogo" :src="userInfo.departLogo == null ? '/static/img/60x45.png' : departLogoImgSrc">
          <span class="companyName">{{userInfo.companyName || '&nbsp;'}}</span>
        </div>
        <div class="user-detail">
          <div class="user-detail-logo">
            <div class="user-detail-logo-div">
              <img id="userInfo_headImg" class="user-detail-logo-img" :src="userInfo.headImg == null ? '/static/img/default-headimg.jpg' : headImgSrc">
            </div>
          </div>
          <div class="user-detail-base">
            <div class="showName" id="userInfo_showName">{{userInfo.showName || '&nbsp;'}}</div>
            <div class="clearfix">
              <div class="item-text">手机号码</div>
              <div class="item">
                <span>{{userInfo.userPhone || '&nbsp;'}}</span>
              </div>
            </div>
            <div class="clearfix">
              <div class="item-text">工作电话</div>
              <div class="item">
                <span>{{userInfo.userPhone || '&nbsp;'}}</span>
              </div>
            </div>
            <div class="clearfix">
              <div class="item-text">电子邮箱</div>
              <div class="item">
                <span>{{userInfo.userEmail || '&nbsp;'}}</span>
              </div>
            </div>
            <div class="clearfix">
              <div class="item-text">通信地址</div>
              <div class="item">
                <span>{{userInfo.address || '&nbsp;'}}</span>
              </div>
            </div>
            <div class="clearfix">
              <div class="item-text">微信昵称</div>
              <div class="item">
                <span>{{userInfo.nickname || '&nbsp;'}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="write-line"></div>
        <div class="clearfix" style="padding-top:18px;">
          <div class="wechat">
            <div class="wechat-div">
              <img class="wxQRCodeImg" :src="userInfo.wxQRCodeImg == null ? '/static/img/weixin-default.png' : wxQRCodeImgSrc">
            </div>
            <div class="wxQRCodeImg-desc">
              微信二维码
            </div>
          </div>
          <div class="introduction">
            <span class="introduction-title" style="">自我介绍</span>
            <span class="introduction-content"> {{userInfo.selfIntroduce || '&nbsp;'}}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import eventBus from '@/plugins/event-bus';
import { loadUserInfoDetail } from '@/services/user/user-service';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'OrgTeamDetailDialog',
  data() {
    return {
      dialogVisible: false,
      showDetailUserId: '',
      userInfo: {}
    };
  },
  created() {
    eventBus.$on('orgDetailTeamDialog', params => {
      this.dialogVisible = true;
      this.showDetailUserId = params;
    });
  },
  methods: {
    async openHandler() {
      try {
        let { data } = await loadUserInfoDetail(this.showDetailUserId);
        if (data.returnCode === '01') {
          this.userInfo = data.user;
          // $('#userInfo_departLogo').on('load', ()=> {
          //   this.imgAutoSize(document.getElementById('userInfo_departLogo'), 60, 45);
          // });
          // $('#userInfo_headImg').on('load', ()=> {
          //   this.imgAutoSize(document.getElementById('userInfo_headImg'), 250, 250);
          // });
        } else {
          this.$message.error('加载用户详细信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    imgAutoSize: function(Img, maxWidth, maxHeight) {
      Img.removeAttribute('width');
      Img.removeAttribute('height');
      if (maxWidth / maxHeight <= Img.width / Img.height) {
        Img.height = maxWidth * (Img.height / Img.width);
        Img.width = maxWidth;
      } else {
        Img.width = maxHeight * (Img.width / Img.height);
        Img.height = maxHeight;
      }
    }
  },
  computed: {
    headImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.userInfo.headImg + '?time=' + Date.now();
      }
    },
    wxQRCodeImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.userInfo.wxQRCodeImg + '?time=' + Date.now();
      }
    },
    departLogoImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.userInfo.departLogo + '?time=' + Date.now();
      }
    }

  }
};

</script>

<style scoped lang="less">
  #OrgTeamDetailDialog {
    .write-line {
      border-top:1px solid #d7d7d7;
      border-bottom:1px solid #fff;
      width:100%;
    }
    .clearfix{
      padding-top:8px;
      font-family:Microsoft YaHei;
      font-size:14px;
      color:#616161
    }
    .company-title {
      height: 63px;
      width: 100%;
      padding-left: 23px;
      padding-right: 41px;
      .company-title-span {
        padding: 6px 2px;
        background: #fe5b3c;
        float: left;
        margin-right: 12px;
      }
      .departLogo {
        width: 60px;
        height: 45px;
        float: left;
        margin-right: 10px;
      }
      .companyName {
        font-family: Microsoft YaHei;
        font-size: 16px;
        font-weight: bold
      }
    }
    .user-detail {
      height: 232px;
      .user-detail-logo {
        width:177px;
        height:100%;
        margin-left:25px;
        float:left;
      }
      .user-detail-logo-div {
        width:138px;
        height:208px;
        display:table-cell;
        vertical-align:middle;
        text-align:center;
        .user-detail-logo-img {
          margin:auto;
          max-width:138px;
          max-height:208px;
          box-shadow:2px 4px 2px #ccc;
        }
      }
      .user-detail-base {
        width:309px;
        height:231px;
        float:left;
        .showName{
          font-size:24px;
          color:#616161;
          font-family:Microsoft YaHei;
        }
        .item-text{
          width:85px;
          float:left;
        }
        .item{
          width:220px;
          float:left;
          font-family:SimSun
        }
      }
    }

    .wechat {
      float:left;
      height:210px;
      width:217px;
      .wechat-div {
        height:142px;
        width:142px;
        padding-left:38px;
        .wxQRCodeImg{
          width: 142px;
          height: 142px;
        }
      }
      .wxQRCodeImg-desc{
        text-align:center;
        color:#616161;
        font-family:Microsoft YaHei;
        font-size:14px;
        padding-top:5px;
      }
    }
    .introduction{
      font-family:SimSun;
      font-size:14px;
      .introduction-title{
        font-weight:bolder;
        color:#616161;
        padding-right:25px;
      }
    }
  }
</style>
